import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// Assets
import logo from '../assets/logo.png'
import { listItems } from '../data/dashboardList';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Avatar, useTheme, useMediaQuery } from '@mui/material';
import moment from 'moment';
import LogoutIcon from '@mui/icons-material/Logout';

const drawerWidth = 260;

const styles = {
  background: {
    backgroundColor: '#FFFFFF'
  },
  logout: {
    position: 'absolute',
    bottom: '20px',
    width: '100%',
    color: '#fff',
    textAlign: 'center',
    cursor: 'pointer',
  }
}

export default function PermanentDrawerLeft({ isLogoutVisible, setIsLogoutVisible, isSelected }) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate()
  const location = useLocation();
  const currentRoute = location.pathname;
  const currentDate = new Date()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerContent = (
    <>
      <div className='flex justify-center border-b-2 mb-4 border-[#f6f6f6]'>
        <img src={logo} className='h-[60px] w-[150px] p-4 mt-4' alt='Logo Im' />
      </div>
      <List className="custom-font flex flex-col items-end">
        {listItems.map((item, index) => (
          <ListItem key={index} disablePadding
            onClick={() => {
              navigate(`${item.route}`)
            }}
            style={{
              background: item.route === isSelected ? 'linear-gradient(to right, #FFBE00, #BA5B00)' : '',
              width: '90%',
              borderTopLeftRadius: '12px',
              borderBottomLeftRadius: '12px',
              padding: '1px',
              height: '42px',
              marginTop: '12px'
            }}
          >
            <ListItemButton style={{ color: item.route === isSelected ? '#fff' : '#000' }}>
              <ListItemIcon style={{ color: item.route === isSelected ? '#fff' : '#000' }}>
                {item.route === isSelected ? item.selectedIcon : item.icon}
              </ListItemIcon>
              <ListItemText primary={item.name} className="custom-font" />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  );

  return (
    <Box sx={{ display: 'flex' }} onClick={() => {
      if (isLogoutVisible) {
        setIsLogoutVisible(false)
      }
    }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ width: isMobile ? '100%' : `calc(100% - ${drawerWidth}px)`, ml: isMobile ? 0 : `${drawerWidth}px`, boxShadow: 'none' }}
        style={styles.background}
      >
        <Toolbar className='w-[100%] flex justify-between'>
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon style={{ color: '#173E81' }} />
            </IconButton>
          )}
          <div className='text-black'>
            {moment(currentDate).format('MMMM, DD, YYYY')}
          </div>
          <div className='flex items-center relative'>
            <Avatar className='ml-2' src='https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png?20150327203541' />
            <div className='text-black ml-2'>
              <div className='font-bold'>Admin <ArrowDropDownSharpIcon onClick={() => setIsLogoutVisible(true)} /></div>
              <div className='text-xs text-[#6C6C6C]'>admin@gmail.com</div>
            </div>
            {isLogoutVisible && (
              <div className='absolute bg-white p-3 px-6 rounded-md cursor-pointer right-2 shadow-lg text-black top-[48px]'
                onClick={() => {
                  setIsLogoutVisible(false)
                  Cookies.remove("token")
                  window.location.reload()
                  navigate('/login')
                }}
              >
                <LogoutIcon /> Logout
              </div>
            )}
          </div>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? mobileOpen : true}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
              backgroundColor: '#FFFFFF',
            },
          }}
          anchor="left"
          style={styles.background}
        >
          {drawerContent}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
      >
        {/* Main content goes here */}
      </Box>
    </Box>
  );
}